import { IconButton, Tooltip } from "@mui/material";
import { green } from "@mui/material/colors";
import { enqueueSnackbar } from "notistack";
import { MouseEvent, ReactNode, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TbCopy, TbCopyCheck } from "react-icons/tb";

import { copyToClipboard } from "@/helpers/strings";

function ClipBoard({ text, children }: { text: string; children: ReactNode }) {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const timer = useRef<number | null>(null);
    const handleClick = async (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (loading) return;
        if (typeof timer === "number") {
            clearInterval(timer);
        }

        setLoading(true);
        const res = await copyToClipboard(text);
        if (res) {
            setCopied(true);
            enqueueSnackbar(t("copied-to-clipboard"), { variant: "success" });
            timer.current = window.setTimeout(() => setCopied(false), 1200);
        }
        setLoading(false);
    };

    return (
        <div className="flex items-center gap-1 justify-between max-w-fit group ">
            {children}
            <Tooltip
                title={copied ? "Kopyalandı!" : "Kopyala"}
                className=" opacity-0 group-hover:opacity-100 duration-200 !h-4"
            >
                <IconButton component="div" onClick={(e) => handleClick(e)}>
                    {copied ? <TbCopyCheck color={green[500]} size={14} /> : <TbCopy size={14} />}
                </IconButton>
            </Tooltip>
        </div>
    );
}
export default ClipBoard;
